import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../client';

function unwrapApiResponse(data: any): any {
  if (data && typeof data === 'object' && 'success' in data && 'data' in data) return data.data;
  return data;
}

export const useEmployees = (workspaceId = '') => {
  return useQuery({
    queryKey: ['employees', workspaceId],
    queryFn: () => client.get('/employees').then(r => r.data).then(unwrapApiResponse),
    enabled: !!workspaceId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useEmployee = (id: string, workspaceId: string) => {
  return useQuery({
    queryKey: ['employee', id, workspaceId],
    queryFn: () => client.get(`/employees/${id}`).then(r => r.data).then(unwrapApiResponse),
    enabled: !!id && !!workspaceId,
  });
};

export const useCreateEmployee = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post('/employees', data).then(r => r.data),
    onSuccess: (_data, vars: any) => qc.invalidateQueries({ queryKey: ['employees', vars.workspaceId] }),
  });
};

export const useUpdateEmployee = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: any) => client.put(`/employees/${id}`, data).then(r => r.data),
    onSuccess: (_data, vars: any) => {
      qc.invalidateQueries({ queryKey: ['employees', vars.workspaceId] });
      qc.invalidateQueries({ queryKey: ['employee', vars.id] });
    },
  });
};

export const useDeleteEmployee = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => client.delete(`/employees/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['employees'] }),
  });
};
